// index.html body-end script — externalized from inline (#10 S2: CSP, no inline <script>).
// Homepage scroll-spy rail + scroll-reveal. Self-contained IIFEs; reads no module imports.
/* Sticky content rail = scroll-spy. The step nearest the viewport middle is active;
   steps above it show a completed check; the purple progress fill grows as you descend. */
(function () {
  var steps = [].slice.call(document.querySelectorAll('.edContent [data-step]'));
  var items = [].slice.call(document.querySelectorAll('.railItem'));
  var fill = document.getElementById('railFill');
  if (!steps.length || !items.length) return;
  function setActive(idx) {
    items.forEach(function (it, i) {
      it.classList.toggle('active', i === idx);
      it.classList.toggle('done', i < idx);
      it.classList.toggle('todo', i > idx);
    });
    if (fill) fill.style.height = (items.length > 1 ? (idx / (items.length - 1)) * 100 : 0) + '%';
  }
  setActive(0);
  if (!('IntersectionObserver' in window)) return;
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) { var i = steps.indexOf(e.target); if (i >= 0) setActive(i); } });
  }, { rootMargin: '-45% 0px -45% 0px', threshold: 0 });
  steps.forEach(function (s) { io.observe(s); });
})();

/* Scroll-reveal: fade/translate blocks in once as they enter view. The hero is never
   hidden (only elements starting below the first viewport are pre-hidden). Respects
   prefers-reduced-motion — under it nothing is hidden and everything shows as-is. */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce || !('IntersectionObserver' in window)) return;
  var els = document.querySelectorAll('[data-reveal]');
  function show(el) { el.style.opacity = '1'; el.style.transform = 'none'; }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { show(e.target); io.unobserve(e.target); }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
  var hidden = [];
  els.forEach(function (el) {
    if (el.getBoundingClientRect().top > window.innerHeight) {
      el.style.opacity = '0';
      el.style.transform = 'translateY(22px)';
      el.style.transition = 'opacity .7s cubic-bezier(.2,.7,.2,1), transform .7s cubic-bezier(.2,.7,.2,1)';
      io.observe(el);
      hidden.push(el);
    }
  });
  // Safety net: content must never stay invisible. If the user hasn't scrolled shortly after
  // load (e.g. a deep-link, a stuck observer, or an automated/at-rest viewport), reveal any
  // still-hidden blocks so the page is fully readable regardless of scroll. A single scroll
  // before then cancels the fallback and lets the on-scroll reveal play as designed.
  if (hidden.length) {
    var scrolled = false;
    var onScroll = function () { scrolled = true; window.removeEventListener('scroll', onScroll); };
    window.addEventListener('scroll', onScroll, { passive: true });
    setTimeout(function () {
      if (!scrolled) hidden.forEach(function (el) { el.style.transition = 'none'; show(el); });
    }, 200);
  }
})();
